import React from "react";
import PropTypes from "prop-types";
import "./skip-link.scss";

const SkipLink = ({ text, to }) => (
  <a href={`#${to}`} className="acca-skip-link">
    {text}
  </a>
);

SkipLink.propTypes = {
  text: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
};

export default SkipLink;
